import { useState } from "react";
import { useNavigate } from "react-router";
import { menuAbout, menuContact } from "../inc/Datamenu_inc";
import ScrollToTopButton from "./SrcollToTopButton";
import { motion } from "framer-motion";

export default function Footer() {
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
        delayChildren: 0.2,
      },
    },
  };

  const itemVariants = {
    hidden: { y: 10, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        duration: 0.5,
        ease: "easeOut",
      },
    },
  };

  const contactItemVariants = {
    rest: { scale: 1 },
    hover: {
      scale: 1.02,
      color: "#0F4D81",
      transition: {
        duration: 0.3,
      },
    },
  };
  return (
    <div className="bottom-0 w-full relative">
      <footer className="bg-[#1c1c1c] text-gray-100 mt-auto h-full lg:h-96">
        <div className="container mx-auto max-w-7xl py-8 px-4">
          <motion.div
            initial="hidden"
            animate="visible"
            variants={containerVariants}
            className="lg:flex lg:flex-row grid grid-cols-1 justify-center items-start gap-x-32"
          >
            {/* Logo */}
            <motion.div
              variants={itemVariants}
              className="w-[200px] md:mx-0 mx-auto mb-8 lg:mb-0"
            >
              <img
                src="/images/logo/logoNovel 1.png"
                className="object-cover lg:block hidden hover:scale-105 transition-transform duration-300"
                alt="NOVEL Logo"
              />
            </motion.div>

            {/* Main Content */}
            <motion.div
              variants={containerVariants}
              className="md:flex grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-32 lg:px-0"
            >
              {/* About Section */}
              <motion.div
                variants={itemVariants}
                className="flex flex-col gap-y-5"
              >
                <div className="flex justify-start items-center space-x-2">
                  <span className="font-bold text-2xl">เกี่ยวกับ</span>
                  <span className="font-bold text-2xl text-[#0F4D81]">เรา</span>
                </div>
                <div>
                  <ul className="flex flex-col gap-y-3">
                    {menuAbout.map((item) => (
                      <motion.li
                        key={item.id}
                        variants={itemVariants}
                        whileHover={{
                          x: 5,
                          color: "#0F4D81",
                        }}
                        className={`${
                          item.status
                            ? "flex gap-x-2 items-center cursor-pointer"
                            : "hidden"
                        }`}
                        onClick={() => navigate(item.link)}
                      >
                        <i className="fa-regular fa-circle-check text-[#0F4D81]"></i>
                        <span className="text-sm">{item.name}</span>
                      </motion.li>
                    ))}
                  </ul>
                </div>
              </motion.div>

              {/* Contact Section - Enhanced with Framer Motion */}
              <motion.div
                variants={itemVariants}
                className="flex flex-col gap-y-5"
              >
                <div className="flex justify-start items-center space-x-2">
                  <span className="font-bold text-2xl">ช่องทางติดต่อ</span>
                  <span className="font-bold text-2xl text-[#0F4D81]">เรา</span>
                </div>
                <div>
                  <ul className="flex flex-col gap-y-3">
                    {/* Address */}
                    <motion.li
                      variants={itemVariants}
                      className="flex gap-x-2 items-start"
                    >
                      <i className="fa-solid fa-map-marker-alt mt-1 text-[#0F4D81]"></i>
                      <span className="text-sm">
                        155 หมู่ที่ 2 ต. แม่เหียะ อ.เมือง จ.เชียงใหม่ 50100
                      </span>
                    </motion.li>

                    {/* Phone */}
                    <motion.li
                      variants={contactItemVariants}
                      initial="rest"
                      whileHover="hover"
                      onClick={() => window.open("tel:0984582500", "_blank")}
                      className="flex gap-x-2 items-center cursor-pointer"
                    >
                      <i className="fa-solid fa-phone-volume text-[#0F4D81]"></i>
                      <span className="text-sm">098 458 2500</span>
                    </motion.li>
                    <motion.li
                      variants={contactItemVariants}
                      initial="rest"
                      whileHover="hover"
                      onClick={() => window.open("tel:053948031", "_blank")}
                      className="flex gap-x-2 items-center cursor-pointer"
                    >
                      <i className="fa-solid fa-phone-volume text-[#0F4D81]"></i>
                      <span className="text-sm">
                        053 948 031 (เวชระเบียน ชั้น 1)
                      </span>
                    </motion.li>
                    <motion.li
                      variants={contactItemVariants}
                      initial="rest"
                      whileHover="hover"
                      onClick={() => window.open("tel:053948112", "_blank")}
                      className="flex gap-x-2 items-center cursor-pointer"
                    >
                      <i className="fa-solid fa-phone-volume text-[#0F4D81]"></i>
                      <span className="text-sm">
                        053 948 112 (เวชระเบียน ชั้น 1)
                      </span>
                    </motion.li>
                    <motion.li
                      variants={contactItemVariants}
                      initial="rest"
                      whileHover="hover"
                      onClick={() => window.open("tel:053948123", "_blank")}
                      className="flex gap-x-2 items-center cursor-pointer"
                    >
                      <i className="fa-solid fa-phone-volume text-[#0F4D81]"></i>
                      <span className="text-sm">
                        053 948 123 (เวชระเบียน ชั้น 2)
                      </span>
                    </motion.li>
                    <motion.li
                      variants={contactItemVariants}
                      initial="rest"
                      whileHover="hover"
                      onClick={() => window.open("tel:053948120", "_blank")}
                      className="flex gap-x-2 items-center cursor-pointer"
                    >
                      <i className="fa-solid fa-phone-volume text-[#0F4D81]"></i>
                      <span className="text-sm">
                        053 948 120 (เวชระเบียนศัลยกรรม)
                      </span>
                    </motion.li>

                    {/* Email */}
                    <motion.li
                      variants={contactItemVariants}
                      initial="rest"
                      whileHover="hover"
                      onClick={() =>
                        window.open(
                          "mailto:novel.vmcmu.serivce@gmail.com",
                          "_blank"
                        )
                      }
                      className="flex gap-x-2 items-center cursor-pointer"
                    >
                      <i className="fa-solid fa-envelope text-[#0F4D81]"></i>
                      <span className="text-sm">
                        novel.vmcmu.serivce@gmail.com
                      </span>
                    </motion.li>
                  </ul>
                </div>
              </motion.div>

              {/* Additional Info Section */}
              <motion.div
                variants={itemVariants}
                className="flex flex-col gap-y-5"
              >
                <div className="flex justify-start items-center space-x-2">
                  <span className="font-bold text-2xl">ข้อมูล</span>
                  <span className="font-bold text-2xl text-[#0F4D81]">
                    เพิ่มเติม
                  </span>
                </div>
                <div>
                  <ul className="flex flex-col gap-y-3">
                    {menuContact.map((item) => (
                      <motion.li
                        key={item.id}
                        variants={itemVariants}
                        whileHover={{
                          x: 5,
                          color: "#0F4D81",
                        }}
                        className={`${
                          item.status
                            ? "flex gap-x-2 items-center cursor-pointer"
                            : "hidden"
                        }`}
                        onClick={() =>
                          item.link.startsWith("https://")
                            ? window.open(item.link, "_blank")
                            : navigate(item.link)
                        }
                      >
                        <i className="fa-regular fa-circle-check text-[#0F4D81]"></i>
                        <span className="text-sm">{item.name}</span>
                      </motion.li>
                    ))}
                  </ul>
                </div>

                {/* Social Media Icons */}
                <motion.div
                  variants={itemVariants}
                  className="flex gap-x-4 mt-3"
                >
                  <motion.a
                    whileHover={{ scale: 1.1, y: -3 }}
                    href="https://www.facebook.com/NOVEL.VMCMU/"
                    target="_blank"
                    className="text-gray-300 hover:text-[#0F4D81] transition-colors"
                  >
                    <i className="fab fa-facebook-f text-xl"></i>
                  </motion.a>
                  <motion.a
                    whileHover={{ scale: 1.1, y: -3 }}
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      setShowModal(true);
                    }}
                    className="text-gray-300 hover:text-[#0F4D81] transition-colors"
                  >
                    <i className="fab fa-line text-xl"></i>
                  </motion.a>
                </motion.div>
              </motion.div>
            </motion.div>
          </motion.div>
        </div>
        <ScrollToTopButton />
      </footer>

      {/* Copyright Section */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.5 }}
        className="bg-[#3a3a3a] text-center text-gray-100 text-xs py-3"
      >
        <p>
          &copy; 2025 NORTHERN REGIONAL VETERINARY HEALTHCARE AND LEARNING
          CENTER.
          <br className="sm:hidden" /> All rights reserved.
        </p>
      </motion.div>
    </div>
  );
}
